export default "__VITE_ASSET__CaccsIZW__"